import script from "./referral-link.vue?vue&type=script&setup=true&lang=js"
export * from "./referral-link.vue?vue&type=script&setup=true&lang=js"

import "./referral-link.vue?vue&type=style&index=0&id=6b333380&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b333380"]])

export default __exports__